// extracted by mini-css-extract-plugin
export default {"mainContent":"Page_mainContent__8cByo"};